module.exports = __webpack_public_path__ + "static/media/decoa_1.30037057.png";